import { gridDefaults } from "@serenity-is/sleekgrid";

// Disable the sanitizer for the grid as we might have javascript code in the returned attributes.
// We need to check all formatters, and also dynamic ones before we can enable this.
gridDefaults.sanitizer = s => s;
